
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.716 25.196v-1.394L23.35 22.62l-.92-5.063-2.43-.748s-.023 1.995 1.442 3.749l-1.25.378s1.497 4.05 5.524 4.261zM39.807 20.935l-1.25-.378c1.465-1.753 1.442-3.75 1.442-3.75l-2.43.75-.92 5.062-2.366 1.183v1.394c4.026-.211 5.524-4.26 5.524-4.26zM32.59 11.626a12.77 12.77 0 012.89 1.08C36.113 11.388 37.256 10 37.256 10c-2.405 0-3.862.88-4.665 1.626zM24.52 12.706a12.77 12.77 0 012.89-1.08C26.607 10.88 25.15 10 22.745 10c0 0 1.143 1.388 1.774 2.706zM24.506 15.579a3.833 3.833 0 002.282 1.189l.165.023a4.982 4.982 0 013.05 1.626 4.981 4.981 0 013.048-1.627l.165-.022a3.832 3.832 0 002.283-1.19l.883-.954c-.964-.689-3.345-2.13-6.38-2.13-3.035 0-5.415 1.441-6.38 2.13l.884.954z","fill":"#fff"}}),_c('path',{attrs:{"d":"M33.114 26.09l-1.37.87-.628-.99 1.998-1.267v-1.627l2.49-1.245 1.05-5.78-.296.319a5.007 5.007 0 01-2.982 1.554l-.165.023a3.814 3.814 0 00-2.713 1.75l-.496.786-.496-.787a3.814 3.814 0 00-2.713-1.75l-.164-.022a5.007 5.007 0 01-2.983-1.554l-.295-.319 1.05 5.78 2.49 1.245v1.627l1.997 1.267-.628.99-1.37-.87v.798a3.112 3.112 0 106.224 0v-.797zm.348-6.818l.448 1.083-1.725.715-.448-1.083 1.725-.715zm-7.368 1.083l.448-1.083 1.725.715-.448 1.083-1.725-.715z","fill":"#fff"}})])
          )
        }
      }
    